// import { Link } from 'react-scroll';
// // import {sjpics} from '../Gallerypics/4K Wallpapers 3 (238).jpg';

// const Hero = () => {
//   return (
//     <section
//       style={{
//         height: '100vh',
//         background: 'linear-gradient(to right, #002F4B, #DC4225)',
        
//         color: 'white',
//         display: 'flex',
//         flexDirection: 'column',
//         justifyContent: 'center',
//         alignItems: 'center',
//         textAlign: 'center',
//         padding: '0 20px'
//       }}
//     >
//       <h1 data-aos="fade-down" style={{ fontSize: '3rem', marginBottom: '1rem' }}>
//         Professional Paint Solutions
//       </h1>
//       <p data-aos="fade-up" style={{ fontSize: '1.2rem', maxWidth: '600px', marginBottom: '2rem' }}>
//         Industrial, Residential, Tennis Courts & Specialized Coating Experts with 35+ Years of Experience
//       </p>
//       <Link to="contact" smooth={true} duration={500}>
//         <button
//           data-aos="zoom-in"
//           style={{
//             background: '#fff',
//             color: '#DC4225',
//             padding: '12px 24px',
//             fontSize: '1rem',
//             border: 'none',
//             borderRadius: '8px',
//             cursor: 'pointer',
//             fontWeight: 'bold'
//           }}
//         >
//           Get a Free Quote
//         </button>
//       </Link>
//     </section>
//   );
// };

// export default Hero;


const Hero = () => {
  return (
    <section id="home" style={{ position: 'relative', height: '100vh', overflow: 'hidden' }}>
      {/* Background Video */}
      <video
        autoPlay
        loop
        muted
        playsInline
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          zIndex: -1
        }}
      >
        <source src="/Gallerypics/Art, 3D, Paint. Free Stock Video.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      {/* Overlay Content */}
      <div
        data-aos="fade-up"
        style={{
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          color: '#fff',
          textAlign: 'center',
          background: 'rgba(0,0,0,0.4)',
          padding: '0 20px'
        }}
      >
        <h1 style={{ fontSize: '3rem', fontWeight: 'bold' }}>
          Welcome to JAS CONTRACTS
        </h1>
        <p style={{ fontSize: '1.2rem', marginTop: '20px' }}>
          Expert in Industrial, Residential & Specialized Surface Painting
        </p>
      
      
      </div>
    </section>
  );
};

export default Hero;
